import React, { createContext, useState, useContext, useEffect } from "react";
import { getPlayerDetail } from "@/services/user";
import { getJudgeDetail } from "@/services/judge";
import { cloneDeep } from "lodash-es";
import { Spin } from "antd";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
const pathList = [
  "/player",
  "/player/detail",
  "/player/personalCases",
  "/player/personalCases/add",
  "/player/personalCases/edit",
];

const judgePathList = [
  "/judgesHomepage",
  "/judgesHomepage/detail",
  "/externalRating",
];

const UserContext = createContext();
let localStorageUserInfo;
let localStorageJudgeInfo;

try {
  localStorageUserInfo = JSON.parse(
    localStorage.getItem("uptoDate_user") || {}
  );
} catch (error) {
  localStorageUserInfo = {};
}

try {
  localStorageJudgeInfo = JSON.parse(
    localStorage.getItem("uptoDate_judge") || {}
  );
} catch (error) {
  localStorageJudgeInfo = {};
}

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const location = useLocation();

  const [user, setUser] = useState(cloneDeep(localStorageUserInfo));
  const [judge, setJudge] = useState(cloneDeep(localStorageJudgeInfo));

  const [isLoading, setLoading] = useState(false);

  const set = (userData) => {
    setJudge({});
    localStorage.removeItem("uptoDate_judge");

    setUser(userData);
    localStorage.setItem("uptoDate_user", JSON.stringify(userData));
    if (!userData?.id && userData?.phone) {
      getUserInfo(userData?.phone);
    }
  };

  const setJudgeInfo = (judgeData) => {
    setUser({});
    localStorage.removeItem("uptoDate_user");

    setJudge(judgeData);
    localStorage.setItem("uptoDate_judge", JSON.stringify(judgeData));
  };

  const getUserInfo = async (phone) => {
    setLoading(true);
    try {
      const res = await getPlayerDetail(phone);
      if (res.code === 200) {
        set(res?.result?.current || {});
      } else {
        set({});
      }
    } catch (error) {
      setLoading(false);
      set({});
    }
    setLoading(false);
  };

  const getJudgeInfo = async (id) => {
    setLoading(true);
    try {
      const res = await getJudgeDetail(id);

      if (res.code === 200) {
        setJudgeInfo(res?.result || {});
      } else {
        setJudgeInfo({});
      }
    } catch (error) {
      setLoading(false);
      setJudgeInfo({});
    }
    setLoading(false);
  };

  // 当路由发生变化时，判断是否需要重新获取用户信息
  useEffect(() => {
    const pathname = location.pathname;
    if (pathList.includes(pathname)) {
      if (user?.phone) {
        getUserInfo(user?.phone);
        return;
      }
    }

    // 当路由发生变化时，判断是否需要重新获取裁判信息
    if (judgePathList.includes(pathname)) {
      if (judge?.id) {
        getJudgeInfo(judge?.id);
      }
    }
  }, [location]);

  // // 监听浏览器进入和离开页面事件
  // useEffect(() => {
  //   window.addEventListener("visibilitychange", () => {
  //     if (document.visibilityState === "visible") {
  //       const pathname = location.pathname;

  //       if (user?.phone && pathList.includes(pathname)) {
  //         getUserInfo(user?.phone);
  //       }

  //       if (judge?.id && judgePathList.includes(pathname)) {
  //         getJudgeInfo(judge?.id);
  //       }
  //     }
  //   });

  //   return () => {
  //     window.removeEventListener("visibilitychange", () => {});
  //   };
  // }, []);

  useEffect(() => {
    let userInfo;
    try {
      userInfo = JSON.parse(localStorage.getItem("uptoDate_user") || {});
    } catch (error) {
      userInfo = {};
    }
    setUser(userInfo);
    if (userInfo?.phone) {
      //  根据手机号重新获取用户信息
      getUserInfo(userInfo?.phone);
    } else {
      let judgeInfo;
      try {
        judgeInfo = JSON.parse(localStorage.getItem("uptoDate_judge") || {});
      } catch (error) {
        judgeInfo = {};
      }
      if (judgeInfo?.id) {
        getJudgeInfo(judgeInfo?.id);
      }
    }
  }, []);

  return (
    <Spin spinning={isLoading}>
      <UserContext.Provider value={{ user, set, judge, setJudgeInfo }}>
        {(!isLoading || (user && user?.phone)) && children}
      </UserContext.Provider>
    </Spin>
  );
};
